import { useState } from "react";
import DownloadSitePdf from "./components/DownloadSitePdf";
import LaunchPopup from "./components/LaunchPopup";

const AppComponents = () => {
  const [isOpen, setIsOpen] = useState(true)

  return <>

    <DownloadSitePdf/>

    <LaunchPopup
      isOpen={isOpen}
      handleClose={() => setIsOpen(false)}
    />
  </>
}

export default AppComponents;